import * as angular from "angular";
import {IController} from "angular";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";

export class PlanningActivityAccountsOverviewComponent implements IController {
  activity: any;
  route: any;
  accounts: any;
  onClose: Function;

  private routeColor: any;

  constructor(private planningCommonService: PlanningCommonService) {
  }

  $onInit() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningActivityAccountsOverview', {
    bindings: {
      activity: '<',
      route: '<',
      accounts: '<',
      onClose: '&'
    },
    template: require('./planning-activity-accounts-overview.html').default,
    controller: PlanningActivityAccountsOverviewComponent
  });

